<header class="app-header navbar">
  <button class="navbar-toggler hidden-lg-up" type="button" appMobileSidebarToggler>&#9776;</button>
  <a class="navbar-brand" href="javascript:void(0);" [routerLink]="['/menu/home']"></a>

  <ul class="nav navbar-nav hidden-md-down">
    <!--
        <li class="nav-item">
            <a class="nav-link navbar-toggler" href="javascript:void(0);" appSidebarToggler> <i class="fa fa-bars"></i></a>
        </li>
        -->
    <!-- 
        <li class="nav-item px-1">
            <a class="nav-link" href="#">Dashboard</a>
        </li>
        <li class="nav-item px-1">
            <a class="nav-link" href="#">Users</a>
        </li>
        <li class="nav-item px-1">
            <a class="nav-link" href="#">Settings</a>
        </li>
        -->
  </ul>

  <ul class="nav navbar-nav ml-auto header-nav-container">
    <li class="nav-item dropdown nav-link" dropdown [placement]="'left'">
      {{username}}
    </li>
    <li class="nav-item dropdown" dropdown [placement]="'left'" (onToggle)="toggled($event)">
      <a
        class="nav-link dropdown-toggle"
        name="langs"
        data-toggle="dropdown"
        href="javascript:void(0);"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
        dropdownToggle
      >
        <i class="fa fa-language fa-2x"></i>
      </a>
      <div
        class="dropdown-menu dropdown-menu-right"
        *dropdownMenu
        aria-labelledby="simple-dropdown"
      >
        <a
          *ngFor="let lang of langs"
          class="dropdown-item text-left"
          href="javascript:void(0);"
          id="{{'changeLang'+lang['id']}}"
          (click)="changeLang(lang['id'])"
        >
          <!--<img class="mr-1" src="{{'assets/img/lang'+lang['id']+'.png'}}" style="height:20px;">-->{{genericVisuals['lang'+lang['id']]}}
        </a>
      </div>
    </li>
    <!--
        <li class="nav-item">
            <a class="nav-link" href="#"><i class="fa fa-bell"></i><span class="badge badge-pill badge-danger">{{unreadNum}}</span></a>
        </li>
        -->
    <li class="nav-item dropdown" dropdown>
      <a
        class="nav-link dropdown-toggle"
        name="settings"
        data-toggle="dropdown"
        href="javascript:void(0);"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
        dropdownToggle
      >
        <i class="fa fa-user fa-2x"></i>
        <span
          class="hidden-md-down pr-05"
          style="display: inline-block; vertical-align: super;"
          >{{user?.companyName}}</span
        >
      </a>
      <div
        class="dropdown-menu dropdown-menu-right"
        *dropdownMenu
        aria-labelledby="simple-dropdown"
      >
        <li
          *ngIf="user.companyName"
          role="menuitem"
          class="hidden-lg-up dropdown-header text-center"
        >
          <span>{{user.companyName}}</span>
        </li>
        <li class="divider dropdown-divider hidden-lg-up m-0"></li>
        <a
          class="dropdown-item"
          href="javascript:void(0);"
          name="changeTheme"
          (click)="changeTheme()"
          ><i class="fa fa-colours"></i>{{genericVisuals.changeTheme}}</a
        >
        <!-- <a class="dropdown-item" href="javascript:void(0);" [routerLink]="['/menu/list']"><i class="fa fa-mail"></i>{{genericVisuals.messages}}<span *ngIf=" unreadMessages > 0 " class="badge badge-success">{{unreadMessages}}</span></a> -->
        <a class="dropdown-item" href="javascript:void(0);" name="logout" (click)="logout()"
          ><i class="fa fa-logout"></i>{{genericVisuals.logout}}</a
        >
      </div>
    </li>
    <!--
        <li class="nav-item hidden-md-down">
            <a class="nav-link navbar-toggler" href="#" appAsideMenuToggler>&#9776;</a>
        </li>
        -->
  </ul>
</header>

<!-- 
    <div style="position: fixed;
    top: 54px;
    right: 0;
    z-index: 9999999;">
    <alert alert-del id="globalError" name="globalError" *ngFor="let alert of alerts" [type]="alert.type" [dismissOnTimeout]="alert.timeout" dismissible="true" [ngSwitch]="alert.type">
        <i *ngSwitchCase="'success'" class="fa fa-check fa-2x" style="float: left; margin-left: -0.5rem; margin-right: 0.5rem;"></i>
        <i *ngSwitchCase="'info'" class="fa fa-exclamation fa-3x" style="float: left; margin-top: -0.75rem; margin-left: -0.5rem; margin-right: 0.5rem;"></i>
        <i *ngSwitchCase="'warning'" class="fa fa-exclamation fa-3x" style="float: left; margin-top: -0.75rem; margin-left: -0.5rem; margin-right: 0.5rem;"></i>
        <i *ngSwitchDefault class="fa fa-plus-circle fa-3x fa-rotate-45" style="float: left; margin-top: -0.75rem; margin-left: -0.5rem; margin-right: 0.5rem;"></i>
        {{ alert.msg }}
    </alert>
</div> 
-->
